// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailPage/DetailPage.scss
// module id = 110
// module chunks = 1